import { MainContentArea, ContentHeader } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useBreadcrumb } from "../../hooks/navigation/useBreadcrumb";
import { InputFormatsList } from "../../components/inputFormats/InputFormatsList";
import { AddInputFormatButton } from "../../components/inputFormats/AddInputFormatButton";

export const InputFormats: React.FC = () => {
  const { t } = useTranslation();
  const breadcrumb = useBreadcrumb("inputFormats");

  return (
    <MainContentArea
      header={
        <ContentHeader
          title={t("inputFormats.title")}
          breadcrumb={breadcrumb}
          extra={<AddInputFormatButton />}
        />
      }
    >
      <InputFormatsList />
    </MainContentArea>
  );
};
